module.exports = __webpack_public_path__ + "img/vengo-media.7329377a.jpg";